const products = () => {
  const productGrids = document.querySelectorAll('.grid--overflow-products')

  if (!productGrids.length) return

  productGrids.forEach((productGrid) => {
    const scrollArea = productGrid.parentElement
    const wrapper = scrollArea.parentElement

    const scrollPrev = wrapper.querySelector('.carousel--btn.prev')
    const scrollNext = wrapper.querySelector('.carousel--btn.next')

    if (!scrollArea || !scrollPrev || !scrollNext) return

    const getScrollAmount = () => {
      const firstArticle = productGrid.querySelector('article')
      if (!firstArticle) return 0

      const styles = window.getComputedStyle(productGrid)
      const gap = parseFloat(styles.columnGap) || 0

      return firstArticle.offsetWidth + gap
    }

    const updateButtons = () => {
      const maxScrollLeft = scrollArea.scrollWidth - scrollArea.clientWidth

      scrollPrev.classList.toggle('is-disabled', scrollArea.scrollLeft <= 0)
      scrollNext.classList.toggle('is-disabled', scrollArea.scrollLeft >= maxScrollLeft - 1)
    }

    scrollPrev.addEventListener('click', () => {
      scrollArea.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth',
      })
    })

    scrollNext.addEventListener('click', () => {
      scrollArea.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth',
      })
    })

    scrollArea.addEventListener('scroll', updateButtons)
    window.addEventListener('resize', updateButtons)

    updateButtons()
  })
}

export default products
